import { useMemo } from "react";
import {
  MAX_FIRSTNAME,
  MAX_LASTNAME,
  MAX_MIDDLENAME,
  WRONG_FIRST_NAME,
  WRONG_LAST_NAME,
  WRONG_MIDDLE_NAME,
  WRONG_NAME_EXTENDED,
} from "../constants";
import { NAME_RULE, NAME_RULE_EXTENDED } from "../validationRules";

export const useCustomersIndividualFormRules = (
  isExtended: boolean = false,
  namePath?: string
) => {
  const formOptions = useMemo(() => {
    return [
      {
        label: "First Name (Name 1)",
        name: namePath ? [namePath, "name1"] : "name1",
        rules: [
          {
            max: 50,
            message: MAX_FIRSTNAME,
            validateTrigger: "onSubmit",
          },
          {
            pattern: isExtended ? NAME_RULE_EXTENDED : NAME_RULE,
            message: isExtended ? WRONG_NAME_EXTENDED : WRONG_FIRST_NAME,
            validateTrigger: "onSubmit",
          },
          {
            required: true,
            validateTrigger: "onSubmit",
          },
        ],
      },
      {
        label: "Middle Name (Name 2)",
        name: namePath ? [namePath, "name2"] : "name2",
        rules: [
          {
            max: 50,
            message: MAX_MIDDLENAME,
            validateTrigger: "onSubmit",
          },
          {
            pattern: isExtended ? NAME_RULE_EXTENDED : NAME_RULE,
            message: isExtended ? WRONG_NAME_EXTENDED : WRONG_MIDDLE_NAME,
            validateTrigger: "onSubmit",
          },
        ],
      },
      {
        label: "Last Name (Name 3)",
        name: namePath ? [namePath, "name3"] : "name3",
        rules: [
          {
            max: 50,
            message: MAX_LASTNAME,
            validateTrigger: "onSubmit",
          },
          {
            pattern: isExtended ? NAME_RULE_EXTENDED : NAME_RULE,
            message: isExtended ? WRONG_NAME_EXTENDED : WRONG_LAST_NAME,
            validateTrigger: "onSubmit",
          },
        ],
      },
    ];
  }, [isExtended, namePath]);

  return { formOptions };
};
